import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';

export const FixedHeightButton = styled(Button)`
  height: 16px;
`;

export const InteractiveFlex = styled(Flex)`
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(212, 212, 212, 0.25);
  }
`;

export const MinWidthModal = styled(Modal)`
  width: 50%;
  max-width: 500px;
`;

export const BoxWithCustomScroll = styled(Box)`
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
  }
`;

export const CustomerInfoDiv = styled.div`
  padding: 3px 0;
`;
